import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map, delay } from 'rxjs/operators';
import { Action } from 'redux';
import { GetSubdomain } from '../action-creators';
import { CreateSubscriptionSuccess } from '@webapp/store/subscription/action-creators';
import { CREATE_SUBSCRIPTION_SUCCESS } from '@webapp/store/subscription/actions';


export const getSubdomainAfterSubscriptionEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, CreateSubscriptionSuccess>(CREATE_SUBSCRIPTION_SUCCESS),
    delay(5000),
    map((action) => new GetSubdomain(action.newSubscription.clientId))
  );